import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomCurrencyPipe } from './custom-currency.pipe';
import { CustomLocationPipe } from './custom-location.pipe';
import { LocalizedDatePipe } from './localized-date.pipe';
import { VrmRegexPipe } from './vrm-regex.pipe';
import { VrmDelimiterPipe } from './vrm-delimiter.pipe';
import { FilterPipe } from './filter.pipe';
import { LocalizedNumberPipe } from './localized-number.pipe';

@NgModule({
  declarations: [
    CustomCurrencyPipe,
    CustomLocationPipe,
    LocalizedDatePipe,
    LocalizedNumberPipe,
    VrmRegexPipe,
    VrmDelimiterPipe,
    FilterPipe,
  ],
  imports: [CommonModule],
  exports: [
    CustomCurrencyPipe,
    CustomLocationPipe,
    LocalizedDatePipe,
    LocalizedNumberPipe,
    VrmRegexPipe,
    VrmDelimiterPipe,
    FilterPipe,
  ],
})
export class CustomPipesModule {}
